<template>

<div>
comp winner !
</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        created() {
           
        },

        data() {

            return {
                
            }

        },

        methods : {

            getData() {
                
                var me = this;

            }

        },

        components : {
        }

    }
</script>
